export default __webpack_public_path__ + "static/image-intro-signup-c7437e3f1e29091a6f1053e267d34064.png";